// Unchecked Guidelines Modal - confirmation dialog when guidelines are not checked

import type { CheckoffGuidelineState } from "./content-guidelines";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@repo/ui";
import { AlertTriangle } from "lucide-react";

interface UncheckedGuidelinesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  uncheckedGuidelines: CheckoffGuidelineState[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function UncheckedGuidelinesModal({
  open,
  onOpenChange,
  uncheckedGuidelines,
  onConfirm,
  onCancel,
}: UncheckedGuidelinesModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="z-[100] pointer-events-auto">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Confirm missing content guidelines
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="overflow-y-auto max-h-[70dvh]">
              <p className="mb-3">
                The brand will be notified that the below guidelines are not
                going to be done:
              </p>
              <ul className="space-y-2 text-sm">
                {uncheckedGuidelines.map((guideline) => (
                  <li key={guideline.type}>
                    {guideline.instructions.map((inst) => (
                      <div
                        key={`${guideline.type}-${inst.text}`}
                        className="flex items-start gap-2 py-1"
                      >
                        <span className="text-muted-foreground">•</span>
                        <span>
                          <strong>{guideline.type}:</strong> {inst.text}
                        </span>
                      </div>
                    ))}
                  </li>
                ))}
              </ul>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Go Back</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Confirm</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
